// session-store.js — 会话状态管理
const listeners = new Set();
let state = { sessions: [], currentSession: null, total: 0 };

export function getSessionState() { return state; }

function sessionTimeValue(session) {
  const raw = session?.lastActiveAt || session?.last_active_at || session?.createdAt || session?.created_at;
  const ts = raw ? Date.parse(raw) : Number.NaN;
  return Number.isFinite(ts) ? ts : 0;
}

function sortSessions(sessions) {
  return [...sessions].sort((a, b) => sessionTimeValue(b) - sessionTimeValue(a) || Number(b.id || 0) - Number(a.id || 0));
}

export function setSessions(sessions, total = 0) {
  state = { sessions: sortSessions(sessions), currentSession: state.currentSession, total };
  emit();
}

export function setCurrentSession(session) {
  state = { ...state, currentSession: session };
  emit();
}

export function upsertSession(session) {
  const idx = state.sessions.findIndex(s => String(s.id) === String(session.id));
  let sessions;
  if (idx >= 0) {
    sessions = [...state.sessions];
    sessions[idx] = { ...sessions[idx], ...session };
  } else {
    sessions = [session, ...state.sessions];
  }
  const currentSession = state.currentSession && String(state.currentSession.id) === String(session.id)
    ? { ...state.currentSession, ...session }
    : state.currentSession;
  state = { ...state, sessions: sortSessions(sessions), currentSession, total: state.total + (idx < 0 ? 1 : 0) };
  emit();
}

export function removeSession(id) {
  state = {
    ...state,
    sessions: state.sessions.filter(s => String(s.id) !== String(id)),
    currentSession: state.currentSession && String(state.currentSession.id) === String(id) ? null : state.currentSession,
  };
  emit();
}

export function subscribe(fn) {
  listeners.add(fn);
  fn(state); // immediately call with current state
  return () => listeners.delete(fn);
}

function emit() {
  for (const fn of listeners) fn(state);
}

// ── Public store object (must be after all functions) ──
export const sessionStore = Object.freeze({ getSessionState, setSessions, setCurrentSession, upsertSession, removeSession, subscribe });
